import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import {
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Card,
  Popover,
  IconButton,
  Chip,
  Paper,
  Grid,
  alpha,
  useTheme,
  MenuItem
} from '@mui/material';
import * as React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getApi } from 'views/services/api';
import { useEffect } from 'react';
import AddComplaint from './AddComplaint';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteComplaint from './DeleteComplaint';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Support as SupportIcon,
  BugReport as BugIcon,
  CheckCircle as ResolvedIcon,
  Schedule as PendingIcon,
  Assignment as ReportIcon,
  CalendarToday as CalendarIcon,
  Priority as PriorityIcon,
  TrendingUp as TrendingUpIcon,
  Visibility as ViewIcon,
  Delete as DeleteActionIcon,
  HeadsetMic as HeadsetIcon
} from '@mui/icons-material';

// ----------------------------------------------------------------------

const Complaint = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [complaintId, setComplaintId] = useState();
  const [complaintData, setcomplaintData] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rowData, setRowData] = useState();

  // functions for opening the dialog boxes ---------------------------------

  // function for  delete dialog/////////////////////////////////////
  const handleOpenDeleteComplaint = (id) => {
    setComplaintId(id);
    setOpenDelete(true);
  };
  const handleCloseDeleteComplaint = () => setOpenDelete(false);
  // function for add dialog/////////////////////////////////////

  const handleOpenAddComplaint = () => setOpenAdd(true);
  const handleCloseAddComplaint = () => setOpenAdd(false);

  const handleOpenview = (complaintId) => {
    console.log('id ==>', complaintId);
    navigate(`/dashboard/complaint/view/${complaintId}`);
  };

  // function for fetching all the rooms data from the db

  const fetchcomplaintData = async () => {
    try {
      const response = await getApi(`api/complaint/viewallcomplaints/${hotel?.hotelId}`);
      setcomplaintData(response?.data?.complaintData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchcomplaintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openDelete]);

  const handleClick = (event, row) => {
    console.log('row on click ==>', row);
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Función para obtener el icono del tipo de reporte
  const getTypeIcon = (type) => {
    const typeMap = {
      bug: BugIcon,
      feature: ReportIcon,
      support: SupportIcon,
      technical: HeadsetIcon
    };
    const IconComponent = typeMap[type?.toLowerCase()] || BugIcon;
    return <IconComponent sx={{ fontSize: 16, color: theme.palette.primary.main }} />;
  };

  // Función para obtener el color del chip según el tipo
  const getTypeColor = (type) => {
    const colorMap = {
      bug: 'error',
      feature: 'info',
      support: 'warning',
      technical: 'primary'
    };
    return colorMap[type?.toLowerCase()] || 'default';
  };

  // Calcular estadísticas
  const totalComplaints = complaintData?.length || 0;
  const resolvedComplaints = complaintData?.filter((complaint) => complaint.status === true)?.length || 0;
  const pendingComplaints = totalComplaints - resolvedComplaints;
  const resolutionRate = totalComplaints > 0 ? Math.round((resolvedComplaints / totalComplaints) * 100) : 0;

  const columns = [
    {
      field: 'type',
      headerName: 'Tipo de Reporte',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize',
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          {getTypeIcon(params.value)}
          <Chip
            label={params.value || 'General'}
            color={getTypeColor(params.value)}
            size="small"
            variant="outlined"
            sx={{
              borderRadius: 2,
              fontWeight: 500,
              fontSize: '0.75rem',
              textTransform: 'capitalize'
            }}
          />
        </Stack>
      )
    },
    {
      field: 'description',
      headerName: 'Descripción del Problema',
      flex: 2,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%'
          }}
        >
          {params.value}
        </Typography>
      )
    },
    {
      field: 'createdDate',
      headerName: 'Fecha de Reporte',
      flex: 1.2,
      renderCell: (params) => {
        const isRecent = moment(params.value).isAfter(moment().subtract(24, 'hours'));
        return (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CalendarIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
            <Box>
              <Typography variant="body2" fontWeight={isRecent ? 600 : 400} color={isRecent ? 'primary' : 'text.primary'}>
                {moment(params.value).format('DD/MM/YYYY')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {moment(params.value).format('HH:mm')}
              </Typography>
            </Box>
          </Stack>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Estado',
      flex: 1,
      cellClassName: `name-column--cell--capitalize`,
      renderCell: (params) => {
        const isResolved = params.value === true;
        return (
          <Chip
            label={isResolved ? 'Resuelto' : 'Pendiente'}
            color={isResolved ? 'success' : 'warning'}
            variant="filled"
            size="small"
            icon={isResolved ? <ResolvedIcon sx={{ fontSize: 16 }} /> : <PendingIcon sx={{ fontSize: 16 }} />}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.75rem',
              minWidth: 100
            }}
          />
        );
      }
    },
    {
      field: 'action',
      headerName: 'Acciones',
      flex: 0.8,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        return (
          <Box>
            <IconButton
              aria-describedby={params?.row._id}
              variant="contained"
              onClick={(event) => handleClick(event, params?.row)}
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.2)
                }
              }}
            >
              <MoreVertIcon sx={{ color: theme.palette.primary.main }} />
            </IconButton>
            <Popover
              id={params?.row._id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  boxShadow: theme.shadows[8],
                  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                }
              }}
            >
              <MenuItem
                onClick={() => handleOpenview(params.row._id)}
                disableRipple
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    bgcolor: alpha(theme.palette.success.main, 0.05)
                  }
                }}
              >
                <ViewIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.success.main }} />
                <Typography variant="body2" fontWeight={500}>
                  Ver Detalles
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => handleOpenDeleteComplaint(params.row._id)}
                disableRipple
                sx={{
                  py: 1.5,
                  px: 2,
                  '&:hover': {
                    bgcolor: alpha(theme.palette.error.main, 0.05)
                  }
                }}
              >
                <DeleteActionIcon sx={{ mr: 1.5, fontSize: 18, color: theme.palette.error.main }} />
                <Typography variant="body2" fontWeight={500} color="error">
                  Eliminar
                </Typography>
              </MenuItem>
            </Popover>
          </Box>
        );
      }
    }
  ];

  return (
    <>
      <AddComplaint open={openAdd} handleClose={handleCloseAddComplaint} />
      <DeleteComplaint open={openDelete} handleClose={handleCloseDeleteComplaint} id={complaintId} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Soporte Técnico
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Reporta y gestiona problemas técnicos del sistema PMS
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <HeadsetIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={3}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <ReportIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalComplaints}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total de Reportes
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <ResolvedIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    {resolvedComplaints}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Casos Resueltos
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.warning.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.warning.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <PendingIcon sx={{ color: theme.palette.warning.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="warning.main">
                    {pendingComplaints}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Casos Pendientes
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <TrendingUpIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    {resolutionRate}%
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Tasa de Resolución
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Controls Section */}
        <Card sx={{ p: 3, mb: 3, borderRadius: 3, border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Centro de Soporte
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Reporta problemas técnicos y errores del sistema para obtener asistencia
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={handleOpenAddComplaint}
              color="error"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1.2,
                boxShadow: theme.shadows[3],
                '&:hover': {
                  boxShadow: theme.shadows[6]
                }
              }}
            >
              Reportar Problema
            </Button>
          </Stack>
        </Card>

        {/* Data Table */}
        <TableStyle>
          <Card
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              '& .MuiDataGrid-root': {
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(theme.palette.error.main, 0.05),
                  borderBottom: `2px solid ${alpha(theme.palette.error.main, 0.1)}`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }
                },
                '& .MuiDataGrid-row': {
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.error.main, 0.02)
                  }
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                }
              }
            }}
          >
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600} color="error.main">
                Reportes de Soporte ({totalComplaints})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Haz clic en un reporte para ver los detalles completos del problema
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              {complaintData && (
                <DataGrid
                  rows={complaintData}
                  columns={columns}
                  checkboxSelection
                  getRowId={(row) => row?._id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: {
                        debounceMs: 500,
                        placeholder: 'Buscar reportes...'
                      }
                    }
                  }}
                  sx={{
                    '& .MuiDataGrid-toolbarContainer': {
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                      p: 2
                    }
                  }}
                />
              )}
            </Box>
          </Card>
        </TableStyle>
      </Container>
    </>
  );
};

export default Complaint;
